<template>
    <div>
        <div class="info-left" v-loading="facetLoading">
            <ul class="left-list">
                <li class="list-tit">分类</li>
                <li class="list" :class="{active:leftNavIndex==item.order}" v-for="(item,index) in navInfo.classification" :key="index" @click="list_click(item)">
                    {{item.facetName}}（{{item.facetCount}}）
                </li>
            </ul>
            <ul class="left-list">
                <li class="list-tit">朝代</li> 
                <li class="list" :class="{active:leftNavIndex==item.order}" v-for="(item,index) in navInfo.dynasty" :key="index" @click="list_click(item)"> 
                    {{item.facetName}}（{{item.facetCount}}）
                </li> 
            </ul>
            <ul class="left-list">
                <li class="list-tit">作者</li>
                <li class="list" :class="{active:leftNavIndex==item.order}" v-for="(item,index) in navInfo.author" :key="index" @click="list_click(item)"> 
                    {{item.facetName}}（{{item.facetCount}}）
                </li> 
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { bookFacetList,entryFacetList} from '../../../io/api.js';
export default {
    props:{
        tabName:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            facetLoading:false, 
            // leftNavIndex:'',//当前选中的分类
            navInfo:{},
            bookNavInfo:{
                classification:[],//分类
                dynasty:[],//朝代
                author:[], //作者
            } ,
            articleNavInfo:{
                classification:[],//分类
                dynasty:[],//朝代
                author:[], //作者
            } 
        }
    },
    mounted(){
        this.getList();
    },
    computed: {
        ...mapState({
            searchVal: state => state.study.searchVal,
            
        }), 
        leftNavIndex: {
            get() {
                return this.$store.state.study.leftNavIndex;
            },
            set(val) {
                return this.$store.state.study.leftNavIndex=val;
            }
        }
    },
    watch: {
        tabName(val,old){ 
            this.getList();
            
        }
    },
    methods: {
        ...mapMutations(['setLeftNavIndex']),
        getList(){ 
            this.facetLoading=true; 
            let params={ 
                keyWord: this.searchVal,
            }
            if(this.tabName=='1'){
                this.getBookList(params);
            }else if(this.tabName=='2') {
                this.getArticleList(params);
            } 
        },
        getBookList(params){
            bookFacetList(params).then(res => {
                let {code, data,msg} = res.data;
                if(code == 0){
                    this.bookNavInfo = data||{}; 
                    this.navInfo = this.bookNavInfo;
                }else{
                    this.$message.error(msg);
                }
                this.facetLoading=false;
            })
        },
        getArticleList(params){
            entryFacetList(params).then(res => {
                let {code, data,msg} = res.data;
                if(code == 0){
                    this.articleNavInfo = data||{}; 
                    this.navInfo = this.articleNavInfo;
                }else{
                    this.$message.error(msg);
                }
                this.facetLoading=false;
            })
        },
        list_click(item){  
            this.setLeftNavIndex(item.order);
            this.$emit('refresh',item);
        }
    }
}
</script>

<style lang="less" scoped>
.info-left{
        width: 200px;
        padding-top: 20px;
        .left-list{
            border: 1px solid #386DE8; 
            margin-bottom: 20px;
            max-height: 296px;
            overflow-y: auto;
            .list{
                height: 36px;
                line-height: 36px;
                padding-left: 8px; 
                color: #386DE8;
                cursor: pointer;
                &:hover{
                    background: #F1F5FE;
                }
                
                &.active{ 
                    background: #F1F5FE;
                    color: #386DE8;
                }
            }
        }
        .list-tit{ 
            font-weight: bold;
            text-align: center;
            font-size: 16px;
            height: 40px;
            line-height: 40px;
            padding-left: 0;
            background: #386DE8;
            color: #fff;
            position: sticky;
            top: 0;
            z-index: 1;
        }
    }
</style>